import styled from "styled-components";

export const AuthLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  gap: ${({ theme }) => theme.tokens.size.sm}px;
`;
